module.exports = __webpack_public_path__ + "static/media/products_services9.4b08681b.jpg";